import { render } from "./PromoCta.vue?vue&type=template&id=f55eb98e"
import script from "./PromoCta.vue?vue&type=script&lang=js"
export * from "./PromoCta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__